import axios from 'axios';
import React from 'react';
import Properties from "../const/Properties";
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import { withRouter } from 'react-router-dom';
import CustomTable from "../thema/tema1/component/CustomTable"
import CustomModal from "../thema/tema1/component/CustomModal"
const active = {Home: "active"};
const tur = {
    1: "ARDİYE",
    2: "PARK",
};
class EkOdemeMuhasebe extends React.Component {
    constructor(props) {
        super(props);
        //alert(this.props.match.params.id);
        this.state = {
            cekiciPlaka: this.props.match.params.id,
            odemeTuru: 0,
            odemeUcreti: 0,
            firmalar:[],
            content:[],
            pageCount:0,
            totalRow:0,
            startRow:0,
            endRow:0,
            silId:0,
            odeId:0,
            duzenleId:0,
            silModal:'none',
            title:["ÖDEME TURU","ÖDEME ÜCRETİ","İŞLEMLER"],
            showDuzenle:false,
            duzenle:false,
            error: 0
        };
        this.handlePageClick({selected:0});
    }

    componentDidMount() {

    }
    silModal = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/ekodeme/delete/'+this.state.silId,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
        .then(res => {
            this.handlePageClick({selected:0});
            window.successful("Ek Ödeme Silindi");
            this.setState({odemeTuru:0});
            this.setState({odemeUcreti:0});
        }).catch(res =>{
            window.unsuccessful("Ek Ödeme Silinemedi.");
    });
        window.disableModal();
    }
    odeModal = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/ekodeme/ode/'+this.state.odeId,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
        .then(res => {
            this.handlePageClick({selected:0});
            window.successful("Ek Ödeme Ödendi");
            this.setState({odemeTuru:0});
            this.setState({odemeUcreti:0});
        }).catch(res =>{
            window.unsuccessful("Ek Ödeme Ödenemedi.");
    });
        window.disableModal();
    }
    save = e => {
        let status = true;
        if(status)
        {
            axios({
                method: 'post',
                url:  Properties.baseUrl+'/ekodeme/save',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization" : "Bearer " + localStorage.getItem("token")
                },
                data: {
                    tasimaId: this.state.tasimaId,
                    odemeTuru: this.state.odemeTuru,
                    odemeUcreti: this.state.odemeUcreti,
                    id:(this.state.showDuzenle?this.state.duzenleId:0)
                }
            })
                .then(res => {
                    this.handlePageClick({selected:0});
                    window.successful((this.state.showDuzenle?"Ek Ödeme Güncellendi.":"Ek Ödeme Kaydedildi"));
                    this.setState({odemeTuru:0});
                    this.setState({odemeUcreti:0});
                }).catch(res =>{
                    window.unsuccessful((this.state.showDuzenle?"Ek Ödeme Güncellenemedi.":"Ek Ödeme Kaydedilemedi."));
            });
            if(this.state.showDuzenle)
                this.setState({showDuzenle:false});
            this.handlePageClick({selected:0});
        }
    }
    geri = ()=>{
        window.location = document.referrer;
    }
    onChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }
    setSil = (e)=>{
        this.setState({silId:e.id});
    }
    setOdeme = (e)=>{
        this.setState({odeId:e.id});
    }
    handlePageClick=e=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/ekodeme/uyari/'+this.state.cekiciPlaka,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.id = eleman.id;
                    elemanIc.odemeTuru = eleman.odemeTuru;
                    elemanIc.odemeUcreti = eleman.odemeUcreti;
                    getData.push(eleman);
                });
                this.setState({firmalar:getData});
                let content = getData.map((item) =>
                                 (<tr>
                                    <td>{tur[item.odemeTuru]}</td>  
                                    <td>{item.odemeUcreti}</td>  
                                    <td>
                                        <div className="row">
                                            <div className="col-2">
                                                <button type="button" className="btn btn-block btn-outline-primary"
                                                        onClick={e => this.setOdeme(item)} data-toggle="modal"
                                                        data-target="#modal-odeme">ÖDEME YAPILDI
                                                </button>
                                            </div>
                                            <div className="col-2">
                                                <button type="button" className="btn btn-block btn-outline-danger"
                                                        onClick={e => this.setSil(item)} data-toggle="modal"
                                                        data-target="#modal-default">SİL
                                                </button>
                                            </div>

                                        </div>
                                    </td>
                                 </tr>));
                this.setState({content: content});
            });
    }
    render() {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu/>
                <PageContext>
                    <form>
                        <div className="card card-primary">
                            <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">{this.state.cekiciPlaka} Plakalı Aracın Borçları</h3>
                        </div>
                        <div className="card-body">
                        <CustomTable state={this.state} getTotalRow={this.getTotalRow} handlePageClick={this.handlePageClick}></CustomTable>
                        </div>
                    </div>
                        </div>

                    </form>
                </PageContext>
                <Footer/>
                <CustomModal id={"modal-default"} funcModal={this.silModal} title={"Ek Ödeme"} content={"Ek Ödemeyi Silmek İstediğinizden Emin Misiniz?"}></CustomModal>
                <CustomModal id={"modal-odeme"} funcModal={this.odeModal} title={"Ek Ödeme"} content={"Ek Ödemeyi Ödendi Yapmak İstediğinizden Emin Misiniz?"}></CustomModal>

            </div>);
    }
}


export default withRouter(EkOdemeMuhasebe);
